import React from 'react';
import PropTypes from 'prop-types';

const LabeledItem = (props) => {
  const {
    label,
    item,
    emptyState,
    icon,
    itemClassName,
    labelIcon,
    message,
  } = props;

  const renderedItem = item || item === 0 ? item : emptyState;
  const itemClass = item || item === 0 ? '' : 'empty-state';

  return (
    <div className="nd-labeled-item">
      <p className="label">
        {labelIcon}
        {label}
      </p>
      <div className="nd-labeled-item__value-col">
        <div className={`item ${itemClass} ${itemClassName}`.trim()}>
          {icon}
          {renderedItem}
        </div>
        {message && <p className="nd-labeled-item__message">{message}</p>}
      </div>
    </div>);
};

export default LabeledItem;

LabeledItem.propTypes = {
  label: PropTypes.string,
  item: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.node,
  ]),
  emptyState: PropTypes.string,
  // Optional icon (e.g. a broker-verification out-of-range warning icon) rendered inline
  // to the left of the value.
  icon: PropTypes.node,
  // Optional extra class(es) applied to the value/`.item` element, e.g. to recolor it.
  itemClassName: PropTypes.string,
  // Optional icon rendered inline to the left of the LABEL text (as opposed to `icon`,
  // which renders next to the VALUE) -- used by the broker-verification (BR-F2) warning
  // icon, which the approved design places next to the label, not the value.
  labelIcon: PropTypes.node,
  // Optional extra content (e.g. the broker-verification "Typical range: ..." text plus an
  // outlier note) rendered as its own line below the value.
  message: PropTypes.node,
};

LabeledItem.defaultProps = {
  label: '',
  item: '',
  emptyState: '',
  icon: null,
  itemClassName: '',
  labelIcon: null,
  message: null,
};

